import AppConstants from '../../../../config/app.constants';

class CustomerPickupReportsController {
    /*@ngInject*/
    constructor(DateUtil, $translate, $q, User, Modal, TimezoneList, SetupService, ShiptypeService, RouteService, CustomerService, 
                $state, LocationService, DataCounter, Navigation, $rootScope) {
        this.DateUtil = DateUtil;
        this.$translate = $translate;
        this.User = User;
        this.Modal = Modal;
        this.TimezoneList = TimezoneList;
        this.SetupService = SetupService;
        this.ShiptypeService = ShiptypeService;
        this.RouteService = RouteService;
        this.CustomerService = CustomerService;
        this.LocationService = LocationService;
        this.DataCounter = DataCounter;
        this.$state = $state;
        this.Navigation = Navigation;
        this.$q = $q;
        this.$rootScope = $rootScope;

        this.model = {
            timezoneList: this.TimezoneList.getTimezoneList(),
            customerPickupReportObj: {
                totalRecords: 0,
                results: [],
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                loading: false
            },
            shiptypeObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            routeListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            customerListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            locationListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            dateRangeOptions: {
                startDate: null,
                endDate: null,
            },
            loggedInUser: User.getUser().id,
            branchId: User.getUser().branchId,
            isCustomerUser: this.User.getUser().customerUser,
            customerId: null,
            userBranchList: [],
            timezone: null,
            isExporting: false,
            branchTimeZone: null
        };
        this.shipTypeLocalLang = {
            nothingSelected: this.$translate.instant('common.select_shiptype'),
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search')
        }
        this.routeLocalLang = {
            nothingSelected: this.$translate.instant('checkout.selectRoute'),
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search')
        }
        this.locationLocalLang = {
            nothingSelected: this.$translate.instant('branch_mgmt.items.locations'),
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search')
        }
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/customer-pickup-reports');
    }

    $onInit() {
        this.model.loading = true;
        if (this.model.isCustomerUser) {
            this.model.customerId = {
                Key: this.model.isCustomerUser ? this.User.getUser().firstName + ' | ' +  this.User.getUser().lastName : null,
                Value: this.model.isCustomerUser ? this.User.getUser().customerId : null, 
            }
        }

        this.$q.all([
            this.SetupService.get(this.model.branchId),
            this.loadshiptype('', 0),
            this.getRouteList('', 0),
            this.getCustomerList('', 0),
            this.getLocationList('', 0)
        ])
            .then((data) => {
                this.model.setupDetails = data[0];
                this.model.branchTimeZone = data[0].timezone;
                this.model.vaultDate = this.DateUtil.convertToDate(this.model.setupDetails.currentVaultDate);
                this.loadDateRangePicker(this.model.vaultDate, this.model.dateRangeOptions, 'dateRange');
                this.model.dateRangeOptions.startDate = moment(this.model.vaultDate).subtract(30, 'days').format('YYYY-MM-DD 00:00:00');
                this.model.dateRangeOptions.endDate = moment(this.model.vaultDate).add(14, 'days').format('YYYY-MM-DD 23:59:59');

                this.customerPickupReport();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    loadDateRangePicker(date, dateRangeOption, modelVal) {
        let currentVaultDate = moment(date).format() || moment();
        this.model[modelVal] = {
            autoApply: true,
            eventHandlers: {
                'apply.daterangepicker': () => {
                    this.reset();
                    this.customerPickupReport();
                }
            },
            ranges: {
                'Running 45 Days': [
                    moment(currentVaultDate).subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).add(14, 'days').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Today': [
                    moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Week': [
                    moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Month': [
                    moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Year': [
                    moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'),
                    moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')
                ]
            }
        }
    }

    loadCustomerReports() {

    }

    loadshiptype(searchKey, offset) {

        searchKey = searchKey || '';

        const shiptypeSearchObj = {
            queryJSON: {
                rules: [
                    {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            },
                            {
                                field: 'description',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }
                            ],
                            operator: 'OR'
                        }
                    }
                ],
                operator: 'AND'
            },
        }

        this.ShiptypeService.all(shiptypeSearchObj, offset, 100)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.model.shiptypeObj.totalRecords = data.total;
                    this.model.shiptypeObj.results = this.mappingShiptypes(data.results);
                }
                else {
                    const shiptype = this.mappingShiptypes(data.results);
                    this.model.shiptypeObj.results = this.model.shiptypeObj.results.concat(shiptype);
                }
            })
    }

    mappingShiptypes(shiptype) {
        return shiptype.map((shiptypes) => {
            return {
                Key: shiptypes.id + " | " + shiptypes.description,
                Value: shiptypes.id
            }
        });
    }

    getRouteList(searchKey, offset) {
        searchKey = searchKey || '';

        const routeSearchObj = {
            queryJSON: {
                rules: [
                    {
                        field: 'branchId',
                        condition: '=',
                        data: this.model.branchId
                    },
                    {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            },
                            {
                                field: 'name',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }
                            ],
                            operator: 'OR'
                        }
                    }
                ],
                operator: 'AND'
            }
        };

        this.model.routeListObj.loading = true;
        return this.RouteService.all(routeSearchObj, offset, 10000)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.model.routeListObj.totalRecords = data.total;
                    this.model.routeListObj.results = this.routeMapping(data.results);
                } else {
                    const routes = this.routeMapping(data.results);
                    this.model.routeListObj.results = this.model.routeListObj.results.concat(routes);
                }
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.routeListObj.loading = false;
            })
    }

    routeMapping(routes) {
        return routes.map((route) => {
            return {
                Key: route.name,
                Value: route.id
            }
        });
    }

    getCustomerList(searchKey, offset) {
        searchKey = searchKey || '';

        const customerSearchObj = {
            queryJSON: {
                rules: [
                    {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            },
                            {
                                field: 'name',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }
                            ],
                            operator: 'OR'
                        }
                    }
                ],
                operator: 'AND'
            }
        };

        this.model.customerListObj.loading = true;
        return this.CustomerService.all(customerSearchObj, offset, AppConstants.defaultPageLimit)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.model.customerListObj.totalRecords = data.total;
                    this.model.customerListObj.results = this.customerMapping(data.results);
                } else {
                    const customers = this.customerMapping(data.results);
                    this.model.customerListObj.results = this.model.customerListObj.results.concat(customers);
                }
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.customerListObj.loading = false;
            })
    }

    customerMapping(customers) {
        return customers.map((customer) => {
            return {
                Key: customer.name,
                Value: customer.id
            }
        });
    }

    getLocationList(searchKey, offset) {
        searchKey = searchKey || '';

        const searchObj = {
            queryJSON: {
                rules: [
                    // {
                    //     field: 'branchId',
                    //     condition: '=',
                    //     data: this.model.branchId
                    // },
                    {
                        field: 'customerId',
                        condition: '!=',
                        data: null
                    },
                    {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            },
                            {
                                field: 'name',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }
                            ],
                            operator: 'OR'
                        }
                    }
                ],
                operator: 'AND'
            }
        };

        if (this.model.customerId) {
            searchObj.queryJSON.rules.push({
                field: 'customerId',
                condition: '=',
                data: this.model.customerId.Value
            })
        }

        this.model.locationListObj.loading = true;
        return this.LocationService.all(searchObj, offset, 10000)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.model.locationListObj.totalRecords = data.total;
                    this.model.locationListObj.results = this.locationMapping(data.results);
                } else {
                    const routes = this.locationMapping(data.results);
                    this.model.locationListObj.results = this.model.locationListObj.results.concat(routes);
                }
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.locationListObj.loading = false;
            })
    }

    locationMapping(locations) {
        return locations.map((loc) => {
            return {
                Key: loc.id + ' | ' + loc.name,
                Value: loc.id
            }
        });
    }

    customerPickupReport() {
        setTimeout(() => {
            const startDate = this.getStartDate();
            const endDate = this.getEndDate();
            const shiptypeId = this.model.shiptypeId.length ? this.model.shiptypeId.map((s) => s.Value) : null;
            const routeId = this.model.routeId.length ? this.model.routeId.map((r) => r.Value) : null;
            const customerId = this.model.customerId ? this.model.customerId.Value : null;
            const locationId = this.model.locationId.length ? this.model.locationId.map((l) => l.Value) : null;

            this.model.customerPickupReportObj.loading = true;
            this.CustomerService.customerPickupReport(this.model.searchText, shiptypeId, startDate, endDate, routeId, customerId, locationId,
                                               (this.model.customerPickupReportObj.pagination.page - 1) * this.model.customerPickupReportObj.pagination.pageLimit, 
                                               this.model.customerPickupReportObj.pagination.pageLimit)
                .then((data) => {
                    this.model.customerPickupReportObj.pagination.total = data.totalRecords;
                    this.model.customerPickupReportObj.results = data.results;
                    this.model.customerPickupReportObj.totalRecords = data.totalRecords;
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.customerPickupReportObj.loading = false;
                })
        })
    }

    getStartDate() {
        return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD') : null;
    }

    getEndDate() {
        return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD') : null;
    }

    pageChange() {
        this.customerPickupReport();
    }

    goToServiceHistory(locationId) {
        const obj = {
            locationId: locationId,
            isRedirected: true
        }
        this.DataCounter.setData(obj);
        this.$state.go('branchManagement.locations');
    }

    goToItemHistory(trackingId) {
        this.Navigation.goToItemHistory(trackingId, null);
    }

    downloadFile(reportPrefix, reportData) {
        const fileName = reportPrefix.concat('.csv');
        const a = document.createElement("a");
        document.body.appendChild(a);
        const file = new Blob([reportData], { type: 'application/csv' });
        const fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = fileName;
        a.click();
      }
    
    exportReports() {
        const startDate = this.getStartDate();
        const endDate = this.getEndDate();
        const shiptypeId = this.model.shiptypeId.length ? this.model.shiptypeId.map((s) => s.Value) : null;
        const routeId = this.model.routeId ? this.model.routeId.Value : null;
        const customerId = this.model.customerId ? this.model.customerId.Value : null;
        const locationId = this.model.locationId ? this.model.locationId.Value : null;
        const reportPrefix = `Customer_Pickup_reports_${customerId ? customerId+"_":''}(${startDate}_${endDate})`;

        this.model.isExporting = true;
        this.CustomerService.exportCustomerPickupReport(this.model.searchText, shiptypeId, startDate, endDate, routeId, customerId, locationId, this.model.branchTimeZone)
            .then((data) => {
                this.downloadFile(reportPrefix, data.reportData)
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message)
                }
            })
            .finally(() => {
                this.model.isExporting = false;
            })
    }

    reset() {
        this.model.customerPickupReportObj.pagination.page = 1;
    }

    resetLocation() {
        setTimeout(() => {
            this.model.locationId = [];
        })
    }
    
    printReport() {
        setTimeout(() => {
            const startDate = this.getStartDate();
            const endDate = this.getEndDate();
            const shiptypeId = this.model.shiptypeId.length ? this.model.shiptypeId.map((s) => s.Value) : null;
            const routeId = this.model.routeId.length ? this.model.routeId.map((r) => r.Value) : null;
            const customerId = this.model.customerId ? this.model.customerId.Value : null;
            const locationId = this.model.locationId.length ? this.model.locationId.map((l) => l.Value) : null;

            this.model.isPrint = true;
            this.CustomerService.customerPickupReport(this.model.searchText, shiptypeId, startDate, endDate, routeId, customerId, locationId, 0, 10000)
                .then((data) => {
                    const group = _.groupBy(data.results, 'customerId');
                    const keys = Object.keys(group);
                    const reportData = [];

                    keys.forEach((key) => {
                        let totalAmount = 0;
                        group[key].forEach(d => totalAmount += d.amount);
                        reportData.push({
                            customer: group[key][0].customerId + ' | ' + group[key][0].customerName,
                            results: group[key],
                            totalRecords: group[key].length,
                            totalAmount
                        })
                    })

                    let url = this.$state.href('customerReportPrint');
                    window.w = window.open(url, '_blank');
                    window.w.printData = {
                        results: reportData,
                        startDate: this.getStartDate(),
                        endDate: this.getEndDate(),
                        branchTimeZone: this.model.branchTimeZone
                    }
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.isPrint = false;
                })
        })
    }

    formattedDate(date, fromVault = false) {
        const validatationTime = moment.utc(date).format('HH:mm:ss');
        if (validatationTime === '00:00:00') {
            return fromVault ? moment.utc(date).format('YYYY-MM-DD') : moment.utc(date).format('YYYY-MM-DD | hh:mm a');
        } else {
            return fromVault ? this.DateUtil.convertDateTime(
                date,
                this.model.branchTimeZone,
                'YYYY-MM-DD'
            ) : this.DateUtil.convertDateTime(
                date,
                this.model.branchTimeZone,
                'YYYY-MM-DD | hh:mm a'
            );
        }
    }
}

export default CustomerPickupReportsController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/customer_pickup_reports/customer_pickup_reports.controller.js